import {LocaleUtils} from '@/utils/locale-utils';
import {SurveyQuestionTypes} from '@/lib/survey-question-types';

export const SurveyQuestionMixin = {
  mixins: [
    LocaleUtils
  ],
  props: {
    question: null,
  },
  data () {
    return {
      SurveyQuestionTypes: SurveyQuestionTypes
    }
  },
  computed: {
    questionAnswers () {
      if (this.readonly) {
        return this.question.surveyAnswers;
      }
      return this.question.surveyAnswers.filter(surveyAnswer => surveyAnswer.deactivatedAt == null);
    }
  },
  methods: {
    isType (...type) {
      return [...type].includes(this.question.type);
    },

    isRadioType () {
      return this.isType(SurveyQuestionTypes.MULTIPLE_CHOICE_SINGLE, SurveyQuestionTypes.YES_NO);
    }
  }
};
